import { getAppStore } from '@src/utils/store-reference';

const buildServiceRoot = () => {
  const store = getAppStore();
  return `/api/requests/${store.selectRequestID()}/versions/${store.selectVersion()}/aquaticResources`;
};

export const AquaticResourceEndpoints = {
  aquaticResources: buildServiceRoot,
  deleteAllAquaticResources: () => `${buildServiceRoot()}/all`,
  getAquaticResourceGeometries: () => `${buildServiceRoot()}/geometries`,
  getAquaticResourceMismatch: () => `${buildServiceRoot()}/validations/state-coordinate-mismatch`,
  getAquaticResourcesWaterNames: () => `${buildServiceRoot()}/water-names`,
  validateAquaticResourceGeometryBoundary: () => `${buildServiceRoot()}/validations/geometry-boundary`,
  validateAquaticResources: () => `${buildServiceRoot()}/validations`,
  validateAquaticResourceUsaceDistrict: () => `${buildServiceRoot()}/validations/usace-district`,
};
